import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import {
  doc,
  onSnapshot,
  collection,
  getDocs,
  updateDoc,
  increment,
} from "firebase/firestore";

import MenuTemplate1 from "../menus/menud1";
import MenuTemplate2 from "../menus/menud2"; 
import MenuTemplate3 from "../menus/menud3";
import MenuTemplate4 from "../menus/menud4";
import MenuTemplate5 from "../menus/menud5";
import MenuTemplate6 from "../menus/menud6";
import "../css/menu.css";

export default function MenuPage() {
  const { menuid } = useParams();
  const navigate = useNavigate();

  const [menu, setMenu] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Load menu data + track views
  useEffect(() => {
    const ref = doc(db, "menus", menuid);

    // Track views every 12h
    const key = `viewed_${menuid}`;
    const last = localStorage.getItem(key);
      updateDoc(ref, { views: increment(1) })
        .catch(() => {});
    

    const unsub = onSnapshot(ref, async (snap) => {
      if (!snap.exists()) {
        navigate("/");
        return;
      }

      const data = snap.data();
      if (data.public === false) {
        alert("This menu is not published.");
        navigate("/");
        return;
      }

      setMenu(data);

      // Load categories + items
      const catRef = collection(db, "menus", menuid, "categories");
      const catSnap = await getDocs(catRef);

      const catList = await Promise.all(
        catSnap.docs.map(async (catDoc) => {
          const itemRef = collection(
            db,
            "menus",
            menuid,
            "categories",
            catDoc.id,
            "items"
          );

          const itemSnap = await getDocs(itemRef);
          const items = itemSnap.docs.map((i) => ({
            id: i.id,
            ...i.data(),
          }));

          return { id: catDoc.id, ...catDoc.data(), items };
        })
      );

      setCategories(catList);
      setLoading(false);
    });

    return () => unsub();
  }, [menuid, navigate]);

  if (loading || !menu) {
    return (
      <div className="menu-loading">
        <div className="shimmer"></div>
      </div>
    );
  }

  // ➜ CHOOSE TEMPLATE BASED ON menu.style
  const style = menu.style || "style1";
  console.log(menu.style);
  return (
    <div className="menu-wrapper">
      {/* Swap menu designs here */}
      {style === "style1" && (
        <MenuTemplate1 menu={menu} categories={categories} />
      )}
        {style === "style2" && <MenuTemplate2  menu={menu} categories={categories}/>}
        {style === "style3" && <MenuTemplate3  menu={menu} categories={categories}/>}
        {style === "style4" && <MenuTemplate4  menu={menu} categories={categories}/>}
        {style === "style5" && <MenuTemplate5  menu={menu} categories={categories}/>}
        {style === "style6" && <MenuTemplate6  menu={menu} categories={categories}/>}
      
    </div>
  );
}
